<h3 [hidden]="!dialogTitle" class="dialog-title">{{ dialogTitle }}</h3>
<div class="dialog" [ngClass]="{ noContentTitle: !dialogTitle }">
  <div class="dialog-content">
    <div [innerHTML]="dialogParams.content"></div>
  </div>
  <div class="dialog-actions">
    <button type="button" class="btn btn-primary" (click)="ok()">{{ okText }}</button>
    <button [hidden]="!cancelText" type="button" class="btn btn-cancel" (click)="cancel()">{{ cancelText }}</button>
  </div>
</div>
